import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./ThemeContext";
import ToolShell from "./ToolShell";
import BlogIndex from "./BlogIndex";
import BlogPost from "./BlogPost";
import MarylandLanding from "./MarylandLanding";
import StateLanding from "./StateLanding";

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Blog */}
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          {/* State landing pages */}
          <Route path="/maryland" element={<MarylandLanding />} />
          <Route path="/texas" element={<StateLanding stateCode="TX" />} />
          <Route path="/florida" element={<StateLanding stateCode="FL" />} />
          <Route path="/illinois" element={<StateLanding stateCode="IL" />} />
          <Route path="/new-york" element={<StateLanding stateCode="NY" />} />
          <Route path="/california" element={<StateLanding stateCode="CA" />} />
          <Route path="/dc" element={<StateLanding stateCode="DC" />} />

          {/* Everything else */}
          <Route path="*" element={<ToolShell />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
